import { ApiClient } from '@bustickus/api';
import {
  IClientAuthBrief,
  IClientAuthFull,
  IClientAuthPostCode,
  IClientAuthPostEmail,
  IClientAuthPostPhone,
} from '@bustickus/models-client';
import { createApiAddress } from 'common/helpers';

class ApiAuth {
  private readonly client: ApiClient = ApiClient.getInstance();
  private static instance: ApiAuth | null = null;

  private constructor() {}

  static getInstance(): ApiAuth {
    if (ApiAuth.instance == null) {
      ApiAuth.instance = new ApiAuth();
    }

    return ApiAuth.instance;
  }

  async resendCodeEmail(sessionId: string): Promise<void> {
    const address = createApiAddress(`/client/auth/session/${sessionId}/send/email`);
    await this.client.sendRequest('get', address);
  }

  async resendCodePhone(sessionId: string): Promise<void> {
    const address = createApiAddress(`/client/auth/session/${sessionId}/send/phone`);
    await this.client.sendRequest('get', address);
  }

  async registerEmail(email: string): Promise<IClientAuthBrief> {
    const address = createApiAddress('/client/auth/register/email');
    const request: IClientAuthPostEmail = {
      email: email,
    };

    const response = await this.client.sendRequest<IClientAuthBrief>('post', address, request);
    return response;
  }

  async registerEmailCode(sessionId: string, code: string): Promise<void> {
    const address = createApiAddress('/client/auth/register/email/code');
    const request: IClientAuthPostCode = {
      sessionId: sessionId,
      code: code,
    };

    await this.client.sendRequest('post', address, request);
  }

  async registerPhone(sessionId: string, phone: string): Promise<void> {
    const address = createApiAddress('/client/auth/register/phone');
    const request: IClientAuthPostPhone = {
      sessionId: sessionId,
      phone: phone,
    };

    await this.client.sendRequest('post', address, request);
  }

  async registerPhoneCode(sessionId: string, code: string): Promise<IClientAuthFull> {
    const address = createApiAddress('/client/auth/register/phone/code');
    const request: IClientAuthPostCode = {
      sessionId: sessionId,
      code: code,
    };

    const response = await this.client.sendRequest<IClientAuthFull>('post', address, request);
    return response;
  }

  async loginEmail(email: string): Promise<IClientAuthBrief> {
    const address = createApiAddress('/client/auth/login/email');
    const request: IClientAuthPostEmail = {
      email: email,
    };

    const response = await this.client.sendRequest<IClientAuthBrief>('post', address, request);
    return response;
  }

  async loginEmailCode(sessionId: string, code: string): Promise<IClientAuthFull> {
    const address = createApiAddress('/client/auth/login/email/code');
    const request: IClientAuthPostCode = {
      sessionId: sessionId,
      code: code,
    };

    const response = await this.client.sendRequest<IClientAuthFull>('post', address, request);
    return response;
  }
}

export default ApiAuth;
